import { React } from 'react';
// import { useNavigate } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';

// import leftCornerLogo from "../../../assets/images/LoginPage/login-left-corner-logo.svg";
// import mainLogo from "../../../assets/images/LoginPage/main-logo.gif";
import awardCxo from "../../../assets/images/LoginPage/cxo logo.svg";
import awardCyberSecurity from "../../../assets/images/LoginPage/cybersecurity_awards_2024.svg";
import awardAegis from "../../../assets/images/LoginPage/aegis_award.svg";

import Reconnaissance from "../../../assets/images/LoginPage/reconnaissance.png";
import ReconnaissanceMotion from "../../../assets/images/LoginPage/reconnaissance-motion.svg";

import Validation from "../../../assets/images/LoginPage/validation.png";
import ValidationMotion from "../../../assets/images/LoginPage/Validation-motion.svg";

import Testing from "../../../assets/images/LoginPage/testing.png";
import TestingMotion from "../../../assets/images/LoginPage/testing-motion.svg";

import Prioritization from "../../../assets/images/LoginPage/prioritization.png";
import PrioritizationMotion from "../../../assets/images/LoginPage/Prioritization-motion.svg";

import Reporting from "../../../assets/images/LoginPage/reporting.png";
import ReportingMotion from "../../../assets/images/LoginPage/reporting-motion.svg";

import Remediation from "../../../assets/images/LoginPage/remediation.png";
import RemediationMotion from "../../../assets/images/LoginPage/remediation-motion.svg";

import { useTranslation } from "react-i18next";

import "./LeftSection.scss";

const LeftSection = () =>{
    const { t } = useTranslation();

    // const navigate = useNavigate();

    return (
        <div className='login-left-section m-3'>
            {/* <div className='left-corner-logo px-4 pt-3'>
                <img src={leftCornerLogo} alt="logo" onClick={()=>{navigate('/auth/login')}}/>
            </div> */}          
            <Carousel controls={false} pause={false}>
                <Carousel.Item interval={3000}>
                <div className="caurosel-container w-100 pt-5 d-flex">
                    <div className="caurosel-left h-100">
                        <img src={Reconnaissance} alt="Reconnaissance" className="w-100 h-100"/>
                    </div>
                    <div className="caurosel-right h-100 px-4">
                        <h2 className="heading">{t('loginPage.leftSection.cauroselContent.reconnaissance.step')}</h2>
                        <div className="gif-container">
                            <img src={ReconnaissanceMotion} alt="ReconnaissanceMotion"/>
                        </div>
                        <div className="content-container mt-5">
                            <h4>{t('loginPage.leftSection.cauroselContent.reconnaissance.heading')}</h4>
                            <p>{t('loginPage.leftSection.cauroselContent.reconnaissance.content1')} <span>{t('loginPage.leftSection.cauroselContent.reconnaissance.content2')}</span> {t('loginPage.leftSection.cauroselContent.reconnaissance.content3')}</p>
                            <p>{t('loginPage.leftSection.cauroselContent.reconnaissance.content4')} <span>{t('loginPage.leftSection.cauroselContent.reconnaissance.content5')}</span></p>
                        </div>
                    </div>
                </div>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <div className="caurosel-container w-100 pt-5 d-flex">
                        <div className="caurosel-left h-100">
                            <img src={Validation} alt="Validation" className="w-100 h-100"/>
                        </div>
                        <div className="caurosel-right h-100 px-4">
                            <h2 className="heading">{t('loginPage.leftSection.cauroselContent.validation.step')}</h2>
                            <div className="gif-container">
                                <img src={ValidationMotion} alt="Validationmotion"/>
                            </div>
                            <div className="content-container mt-5">
                                <h4>{t('loginPage.leftSection.cauroselContent.validation.heading')}</h4>
                                <p>{t('loginPage.leftSection.cauroselContent.validation.content1')}<span> {t('loginPage.leftSection.cauroselContent.validation.content2')}</span></p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <div className="caurosel-container w-100 pt-5 d-flex">
                        <div className="caurosel-left h-100">
                            <img src={Testing} alt="Multi-stage testing" className="w-100 h-100"/>
                        </div>
                        <div className="caurosel-right h-100 px-4">
                            <h2 className="heading">{t('loginPage.leftSection.cauroselContent.testing.step')}</h2>
                            <div className="gif-container">
                                <img src={TestingMotion} alt="Multi-stage testing"/>
                            </div>
                            <div className="content-container mt-5">
                                <h4>{t('loginPage.leftSection.cauroselContent.testing.heading')}</h4>
                                <p>{t('loginPage.leftSection.cauroselContent.testing.content1')} <span>{t('loginPage.leftSection.cauroselContent.testing.content2')}</span></p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <div className="caurosel-container w-100 pt-5 d-flex">
                        <div className="caurosel-left h-100">
                            <img src={Prioritization} alt="Prioritization" className="w-100 h-100"/>
                        </div>
                        <div className="caurosel-right h-100 px-4">
                            <h2 className="heading">{t('loginPage.leftSection.cauroselContent.prioritization.step')}</h2>
                            <div className="gif-container">
                                <img src={PrioritizationMotion} alt="Prioritization"/>
                            </div>
                            <div className="content-container mt-5">
                                <h4>{t('loginPage.leftSection.cauroselContent.prioritization.heading')}</h4>
                                <p><span>{t('loginPage.leftSection.cauroselContent.prioritization.content1')}</span> {t('loginPage.leftSection.cauroselContent.prioritization.content2')}</p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <div className="caurosel-container w-100 pt-5 d-flex">
                        <div className="caurosel-left h-100">
                            <img src={Reporting} alt="Reporting" className="w-100 h-100"/>
                        </div>
                        <div className="caurosel-right h-100 px-4">
                            <h2 className="heading">{t('loginPage.leftSection.cauroselContent.reporting.step')}</h2>
                            <div className="gif-container">
                                <img src={ReportingMotion} alt="Reporting"/>
                            </div>
                            <div className="content-container mt-5">
                                <h4>{t('loginPage.leftSection.cauroselContent.reporting.heading')}</h4>
                                <p>{t('loginPage.leftSection.cauroselContent.reporting.content1')} <span>{t('loginPage.leftSection.cauroselContent.reporting.content2')}</span></p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <div className="caurosel-container w-100 pt-5 d-flex">
                        <div className="caurosel-left h-100">
                            <img src={Remediation} alt="Remediation" className="w-100 h-100"/>
                        </div>
                        <div className="caurosel-right h-100 px-4">
                            <h2 className="heading">{t('loginPage.leftSection.cauroselContent.remediation.step')}</h2>
                            <div className="gif-container">
                                <img src={RemediationMotion} alt="Remediation"/>
                            </div>
                            <div className="content-container mt-5">
                                <h4>{t('loginPage.leftSection.cauroselContent.remediation.heading')}</h4>
                                <p>{t('loginPage.leftSection.cauroselContent.remediation.content1')} <span>{t('loginPage.leftSection.cauroselContent.remediation.content2')}</span></p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
            </Carousel>
            <div className="left-footer-container mb-3">
                <div className="award-section w-100 d-flex justify-content-center align-items-center">
                    <img src={awardCxo} alt="award_cxo"/>
                    <img className="aegis-award" src={awardAegis} alt="award_aegis"/>
                    <img src={awardCyberSecurity} alt="award_cyber"/>                
                </div>
                <div className='bottom-text text-center mt-1'>
                    <p>{t('loginPage.leftSection.footerText')}</p>
                </div>
            </div>            
        </div>
    )
}

export default LeftSection;